import DeleteForever from '@mui/icons-material/DeleteForever';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function DeleteForeverIcon(props: FixMe) {
  return <DeleteForever {...props} />;
}

export default DeleteForeverIcon;
